export default {
  prepareSequenceImages: Array(33)
    .fill('')
    .map((v, i) =>
        require(`../../../Box_sequences/Bespoke_Cube123/bespoke123_${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/cube123/winerackdog.png'),
  designImageList: [
    {
      number: 1,
      side: 'MIDDLE',
      image: require('../../../parts/winerackdog/01.png'),
    },
    {
      number: 2,
      side: 'RIGHT',
      image: require('../../../parts/winerackdog/02.png'),
    },
    {
      number: 3,
      side: 'LEFT',
      image: require('../../../parts/winerackdog/03.png'),
    },
    {
      number: 4,
      side: 'FRONT',
      image: require('../../../parts/winerackdog/04.png'),
    },
    {
      number: 5,
      side: 'BACK',
      image: require('../../../parts/winerackdog/05.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/winerackdog/06.png'),
  assembleSequenceImages: Array(50)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/32_winerack_dog/winerackdog${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/wine rack Dog.png'),
  completeImagePc: require('../../../complete/wine rack Dog.png'),
};
